import { Observable } from 'rxjs';
import { ContactsApi, PagedContactResponse } from 'src/app/hickory-api';
import { contactData } from './data/ContactData';
import { getPage } from './data/PageHelper';
import { getSingle } from './data/SingleHelper';
import { mockHandler } from '../mock.handler';

export class MockContactsApi extends ContactsApi {

  getContacts(contactIds?: Array<number>, forcedContactIds?: Array<number>, externalIds?: Array<string>, groupId?: number, groupIds?: Array<number>, includeNestedGroups?: boolean,
    page?: number, pageSize?: number, search?: string, chatEnabledOnly?: boolean)
    : Observable<any> {
    const filtered = contactData.all.filter(c => (contactIds ? contactIds.indexOf(c.id) >= 0 : true)
      && (search ? (c.firstName + ', ' + c.lastName).toLowerCase().indexOf(search.toLowerCase()) >= 0 : true));
    const paged: PagedContactResponse = getPage(filtered, page, pageSize);
    return mockHandler(paged);
  }

  public getContact(id: number): Observable<any> {
    const item = contactData.all.find(c => c.id === id);
    const single: PagedContactResponse = getSingle(item);
    return mockHandler(single);
  }
}
